var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('default-template', [_c('v-container', [_c('v-row', [!_vm.$vuetify.breakpoint.mobile ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "width": "260",
      "tile": "",
      "flat": "",
      "elevation": "0"
    }
  }, [_c('v-card', {
    staticClass: "py-30px white--text",
    attrs: {
      "color": "#366fd7",
      "elevation": "0",
      "flat": "",
      "tile": "",
      "to": "/mypage"
    }
  }, [_c('v-card-title', {
    staticClass: "py-0"
  }, [_c('span', {
    staticClass: "tit tit--sm"
  }, [_vm._v("마이페이지")])])], 1), _c('v-list', [_vm._l(_vm.items, function (item) {
    return [_c('v-list-group', {
      key: item.title,
      attrs: {
        "value": _vm.getIsOpen(item)
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn() {
          return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)];
        },
        proxy: true
      }], null, true)
    }, [_c('v-list-item-group', [_vm._l(item.items, function (item) {
      return [_c('v-list-item', {
        key: item.title,
        attrs: {
          "dense": "",
          "to": item.route
        }
      }, [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)];
    })], 2)], 1)];
  })], 2)], 1)], 1) : _vm._e(), _c('v-col', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_vm._t("default")], 2)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }